import {
  AvatarUser,
  Backdrop,
  ContainerPrivateHeaderDesktop,
  ContainerUserData,
  HeaderMobileMenu,
  LogoSafeTasker,
  MenuButton,
  MenuButtonHeader,
  MenuContent,
  MenuData,
  MenuDataDesktop,
  MobileContainer,
  MobileHeaderContainer,
  NameUser,
  NicNameUserColor,
  PrivateHeaderContainer,
} from "./PrivateHeaderStyles.styled";
import { useState } from "react";

import useAuth from "../../../../Redux/useAuth";
import { NavLink } from "react-router-dom";
import { useLanguageContext } from "../../../../Components/Languages/Langs/LanguageContext";
import {
  BurgerMobileMenu,
  CloseButtonMenuIcon,
  SettingAccountUser,
} from "./setIcon";
import { LogoApp } from "../../../../Components/LogoApp/LogoApp";

export const PrivateHeader = () => {
  const { user } = useAuth();
  const { t } = useLanguageContext();

  const [showMenu, setShowMenu] = useState(false);
  const handleShowNavbar = () => {
    setShowMenu(!showMenu);
  };

  return (
    <>
      <MobileContainer>
        <MobileHeaderContainer>
          <LogoSafeTasker to={`/home-page/${user?.name?.toLowerCase()}`}>
            <LogoApp />
          </LogoSafeTasker>
          <MenuButtonHeader type="button" onClick={handleShowNavbar}>
            <BurgerMobileMenu />
          </MenuButtonHeader>
        </MobileHeaderContainer>

        <PrivateHeaderContainer
          className={`menu-active ${showMenu && "active"}`}
        >
          <Backdrop className="backdrop" onClick={handleShowNavbar} />
          <MenuContent>
            <ContainerUserData>
              <HeaderMobileMenu>
                <LogoApp />
                <MenuButton type="button" onClick={handleShowNavbar}>
                  <CloseButtonMenuIcon />
                </MenuButton>
              </HeaderMobileMenu>
              <MenuData>
                <NameUser>
                  {t("privateTraslate.privateHeaderNameUser")}
                  <NicNameUserColor> {user?.name || "User"}</NicNameUserColor>
                </NameUser>
                <AvatarUser
                  crossOrigin="anonymous"
                  src={user?.avatarUser ?? undefined}
                  alt={`${user?.name || "User"}'s avatar`}
                />
                <NavLink
                  to={`/home-page/${user?.name?.toLowerCase()}/main-info`}
                >
                  <SettingAccountUser />
                </NavLink>
              </MenuData>
            </ContainerUserData>
          </MenuContent>
        </PrivateHeaderContainer>
      </MobileContainer>
      <ContainerPrivateHeaderDesktop>
        <LogoSafeTasker to={`/home-page/${user?.name?.toLowerCase()}`}>
          <LogoApp />
        </LogoSafeTasker>
        <MenuDataDesktop>
          <NameUser>
            {t("privateTraslate.privateHeaderNameUser")}
            <NicNameUserColor> {user?.name || "User"}</NicNameUserColor>
          </NameUser>
          <AvatarUser
            crossOrigin="anonymous"
            src={user?.avatarUser ?? undefined}
            alt={`${user?.name || "User"}'s avatar`}
          />
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/main-info`}>
            <SettingAccountUser />
          </NavLink>
        </MenuDataDesktop>
      </ContainerPrivateHeaderDesktop>
    </>
  );
};
